import React from "react";
import { Page, Navbar, Block, Link, Icon } from "framework7-react";
const Page404 = () => {
  return (
    <Page>
      <div className="container container-table  ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space mb-3">
            <div className="custom-container p-0">
              <div className="header-panel">
                <Link href="#" back><Icon ios="material:keyboard_arrow_left" aurora="material:keyboard_arrow_left" md="material:keyboard_arrow_left" className='theme-dark' backLink="Back" ></Icon></Link>
                <h2>Not Found</h2>
              </div>
            </div>
          </header>
          <Block className="text-center">
            <p>Sorry</p>
            <p>Requested content not found.</p>
          </Block>
        </div>
      </div>
    </Page>
  );
};

export default Page404;